import React from 'react';
import NewsCategoryMenu from './NewsCategoryMenu.jsx';
import SubNews from './SubNews.jsx';
import MainNews from './MainNews.jsx';
import style from './style.scss';
import {Articles} from 'api';
import {LoadingPage} from 'components/loading-page';

class NewsCategory extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      count: 0,
      skip: 0,
      limit: 10,
      order: 'id DESC',
      mainNews: null,
      isLoading: false,
      categoryId: this.props.params.id
    };
    this.loadMore = this.loadMore.bind(this);
  }

  componentDidMount() {
    if (this.state.categoryId) {
      let params = {
        where: {
          categoryId: this.state.categoryId
        }
      };
      Articles.actions.countArticle.request(params).then((response) => {
        this.setState({count: response.data.count});
        this.getData();
      }).catch((error) => {
        this.props.history.push('/');
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.categoryId !== nextProps.params.id) {
      this.setState({data: [], categoryId: nextProps.params.id});
      this.getData();
    }
  }

  getData() {
    this.setState({isLoading: true});
    let params = {
      filter: {
        limit: this.state.limit,
        order: this.state.order,
        skip: this.state.skip,
        where: {
          categoryId: this.state.categoryId
        }
      }
    };
    Articles.actions.list.request(params).then(response => {
      let topNews = response.data[0];
      let news = this.state.data;
      response.data.map((item, idx) => {
        if (item.id !== topNews.id) {
          news.push(item);
        }
      });
      this.setState({data: news, mainNews: topNews, isLoading: false});
    }).catch((error) => {
      this.setState({isLoading: false});
    });
  }

  loadMore() {
    this.setState({skip: this.state.skip + 10}, () => {
      this.getData();
    });
  }

  render() {
    const categoryNewsMenuClass = 'news-left-menu ' + (this.state.toggeled ? 'opened' : '');
    return (
      <section className="center">
        <LoadingPage isShow={this.state.isLoading} />
        <div className='news-container'>
          <div className={categoryNewsMenuClass}>
            <NewsCategoryMenu/>
          </div>
          <div className='news-right-content'>
            <h2 className='news-title'>Tin tức</h2>
            <div className='news-main-item'>
              {
                this.state.mainNews == null ? (
                  <p>Không có tin tức nào</p>
                ) : (
                  <MainNews {...this.state.mainNews}/>
                )
              }
            </div>
            <div className='news-list-sub-item'>
              {
                this.state.data.map((item, i) => {
                  return (
                    <SubNews key={i} {...item}/>
                  );
                })
              }
            </div>
            {
              (this.state.skip + this.state.limit) < this.state.count && this.state.data.length != 0 ? (
                <div className='wrap-btn-viewmore' onClick={this.loadMore}>
                  <button className='btn-news-viewmore'>Xem Thêm</button>
                </div>
              ) : (
                null
              )
            }
          </div>
        </div>
      </section>
    );
  }
}

export default NewsCategory;



// WEBPACK FOOTER //
// ./components/news/NewsCategory.jsx